<template>
  <div class="contact-page">
    <h1 class="contact-title">Contact The Academy</h1>
    <section class="contact-section">
      <div class="contact-info">
        <img src="969699.png" alt="Contact" class="contact-img" />
        <h2>Contact Details</h2>
        <p><strong>WhatsApp:</strong> <a href="https://wa.me/+201118696626" target="_blank">+201118696626</a></p>
        <p><strong>Phone:</strong> <a href="tel:+201118696626">+201118696626</a></p>
        <p><strong>Email:</strong> <a href="mailto:info@academy-robotics.com">info@robotoschool.com</a></p>
        <p><strong>Address 1:</strong> Sheikh Zayed, Villa 227, District 8, Block 3, in front of Plaza Espana.</p>
        <p><strong>Address 2:</strong> Tanta, Hassan Radwan Street, Zahret Al-Radwan Tower, First Floor.</p>
      </div>
      <form class="contact-form" @submit.prevent="submitForm">
        <h2>Contact Us</h2>
        <div class="form-group">
          <label for="name">Your Name</label>
          <input
            id="name"
            v-model="form.name"
            type="text"
            placeholder="Enter your name"
            :class="{'is-invalid': errors.name}"
            required
          />
          <span v-if="errors.name" class="error-message">{{ errors.name }}</span>
        </div>
        <div class="form-group">
          <label for="email">Your Email</label>
          <input
            id="email"
            v-model="form.email"
            type="email"
            placeholder="Enter your email"
            :class="{'is-invalid': errors.email}"
            required
          />
          <span v-if="errors.email" class="error-message">{{ errors.email }}</span>
        </div>
        <div class="form-group">
          <label for="phone">Your Phone</label>
          <input
            id="phone"
            v-model="form.phone"
            type="tel"
            placeholder="Enter your phone number"
            :class="{'is-invalid': errors.phone}"
            required
          />
          <span v-if="errors.phone" class="error-message">{{ errors.phone }}</span>
        </div>
        <div class="form-group">
          <label for="message">Your Message</label>
          <textarea
            id="message"
            v-model="form.message"
            rows="5"
            placeholder="Write your message here"
            :class="{'is-invalid': errors.message}"
            required
          ></textarea>
          <span v-if="errors.message" class="error-message">{{ errors.message }}</span>
        </div>
        <button type="submit" class="submit-button">Send Message</button>
      </form>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ContactPage',
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      errors: {}
    };
  },
  methods: {
    submitForm() {
      this.errors = {};
      if (!this.form.name) {
        this.errors.name = 'Name is required.';
      }
      if (!this.form.email) {
        this.errors.email = 'Email is required.';
      } else if (!this.validateEmail(this.form.email)) {
        this.errors.email = 'Invalid email address.';
      }
      if (!this.form.phone) {
        this.errors.phone = 'Phone number is required.';
      }
      if (!this.form.message) {
        this.errors.message = 'Message is required.';
      }
      if (Object.keys(this.errors).length === 0) {
        this.sendEmail();
      }
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    sendEmail() {
      const emailData = {
        to: 'info@robotoschool.com',
        subject: 'New Contact Form Submission',
        body: `Name: ${this.form.name}\nEmail: ${this.form.email}\nPhone: ${this.form.phone}\nMessage: ${this.form.message}`
      };
      // Simulate email sending
      alert(`Email sent to ${emailData.to} with subject: ${emailData.subject}\n\n${emailData.body}`);
    }
  }
};
</script>

<style scoped>
.contact-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 2rem 1rem;
  font-family: 'Cairo', Arial, sans-serif;
  background: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.contact-title {
  text-align: center;
  font-size: 2.5rem;
  color: #1976d2;
  margin-bottom: 2rem;
  font-weight: bold;
}
.contact-section {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 2rem;
}
.contact-info {
  flex: 1;
  min-width: 280px;
  text-align: center;
}
.contact-info img {
  width: 100%;
  max-width: 300px;
  height: auto;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
}
.contact-info h2 {
  color: #1976d2;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: bold;
}
.contact-info p, .contact-info a {
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 0.7rem;
  text-decoration: none;
  line-height: 1.6;
}
.contact-info a:hover {
  color: #1976d2;
  text-decoration: underline;
}
.contact-form {
  flex: 1;
  min-width: 280px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 2rem;
}
.contact-form h2 {
  text-align: center;
  margin-bottom: 1.5rem;
  color: #1976d2;
  font-size: 1.8rem;
  font-weight: bold;
}
.form-group {
  margin-bottom: 1.5rem;
}
.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: #555;
}
.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s;
}
.form-group input:focus,
.form-group textarea:focus {
  border-color: #1976d2;
  outline: none;
}
.form-group input.is-invalid,
.form-group textarea.is-invalid {
  border-color: #e74c3c;
}
.error-message {
  color: #e74c3c;
  font-size: 0.9rem;
  margin-top: 0.3rem;
  display: block;
}
.submit-button {
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.8rem 1.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s;
  display: block;
  width: 100%;
}
.submit-button:hover {
  background: #1565c0;
}
@media (max-width: 900px) {
  .contact-section {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }
  .contact-info img {
    max-width: 100%;
    height: auto;
  }
  .contact-form {
    padding: 1rem;
  }
}
</style>
